// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__1fusd","title":"NotFound_title__D8KzW","message":"NotFound_message__obVKA","link":"NotFound_link__D0B5M"};